module.exports = __webpack_public_path__ + "static/banner-tablet-c0bf58cc81ed48f96682edea2a033c8d.png";